module.exports = __webpack_public_path__ + "static/media/aam-relationships.2733c1ea.jpg";